<template>
  <div class="flow-user-select">
    <el-tag v-if="selectRow.id" size="medium" :disable-transitions="false">{{selectRow.name}}</el-tag>
    <el-button circle class="flow-user-select-addButton" icon="el-icon-plus" size="small" @click="addGeneral" />
    <!-- 通用选择器 弹窗 -->
    <el-dialog title="请选择用户" :visible.sync="generalSelectShow" :append-to-body="true" width="1000px" top="5vh">
      <!-- 搜索条件 -->
      <el-form :inline="true" :model="searchForm" label-width="80px">
        <el-form-item label="姓名">
          <el-input clearable v-model="searchForm.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="部门">
          <el-input clearable v-model="searchForm.orgName" placeholder="请输入部门"></el-input>
        </el-form-item>
        <el-form-item label="学工号">
          <el-input clearable v-model="searchForm.loginName" placeholder="请输入学工号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="mainTableReload">查询</el-button>
        </el-form-item>
      </el-form>

      <el-table ref="table" v-loading="tableLoading" element-loading-text="拼命加载中..." :data="tableData" height="400px"
        @selection-change="selectionChange" :border="true" row-key="id" @row-click="rowClick" style="width: 100%">
        <!-- 空插槽 border -->
        <template slot="empty">
          <avue-empty></avue-empty>
        </template>
        <el-table-column align="center" fixed="left" width="50" type="selection" prop="id"></el-table-column>
        <el-table-column prop="name" show-overflow-tooltip label="姓名">
        </el-table-column>
        <el-table-column prop="orgName" show-overflow-tooltip label="部门">
        </el-table-column>
        <el-table-column prop="loginName" show-overflow-tooltip label="工号">
        </el-table-column>
      </el-table>
      <nav style="text-align: right;margin:10px 0">
        <el-pagination background small @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="paging.currentPage || 1" :page-sizes="[15, 25, 35, 45]" :page-size="paging.pageSize"
          layout="total, sizes, pager, jumper" :total="paging.total  "></el-pagination>
      </nav>
      <el-row>
        <el-col span="24">
          <div style="text-align:center;margin-top:20px" class="btnGroup">
            <el-row>
              <el-col>
                <el-button @click="generalSelectShow = false">关 闭</el-button>
                <el-button style="margin-left:100px;" type="primary" @click="submit">确 认</el-button>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { deepClone } from '@/framework/util/util.js'
export default {
  data() {
    return {
      paging: {
        currentPage: 1,
        pageSizes: [15, 20, 25, 30],
        pageSize: 15,
        total: 0
      },
      tableData: [],
      tableLoading: false,
      searchForm: {
        name: '',
        orgName: '',
        loginName: ''
      },
      selectRow: {},
      selectRowTemp: {},
      generalSelectShow: false
    }
  },
  props: {
    // 已经选择的对象
    value: {
      type: Array,
      default: () => []
    },
    // 已经选择的对象
    display: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    selectionChange(selection) {
      let length = selection.length
      if (length > 2) {
        this.$refs.table.selection = this.$refs.table.selection.splice(0, this.$refs.table.selection.length)
        this.selectRowTemp = {}
      } else if (length === 2) {
        this.$refs.table.selection = this.$refs.table.selection.splice(0, this.$refs.table.selection.length - 1)
        this.selectRowTemp = this.$refs.table.selection[0]
      } else if (length === 1) {
        this.selectRowTemp = this.$refs.table.selection[0]
      } else if (length === 0) {
        this.selectRowTemp = {}
      }
      // this.$emit('input', this.selectRow)
    },
    submit() {
      if (this.$refs.table.selection.length === 0) {
        this.$message.info('请选择用户。')
        return
      }
      this.generalSelectShow = false
      this.selectRow = this.selectRowTemp
      this.$emit('input', this.selectRowTemp)
    },
    rowClick(row, event, column) {
      this.$refs.table.toggleRowSelection(row)
    },
    handleSizeChange(size) {
      this.paging.pageSize = size
      this.mainTableReload()
    },
    handleCurrentChange(currentPage) {
      this.paging.currentPage = currentPage
      this.mainTableReload()
    },
    mainTableReload() {
      // 先存储一下选中节点的数据,免得被清空了
      let { id, name, orgName, loginName } = this.selectRowTemp
      this.tableLoading = true
      this.$http.get('/default-workflow-user-choose/search', {
        params: {
          pageSize: this.paging.pageSize,
          pageNum: this.paging.currentPage,
          loginName: this.searchForm.loginName || null,
          name: this.searchForm.name || null,
          orgName: this.searchForm.orgName || null
        }
      }).then(response => {
        this.tableData = response.data.records
        this.paging.total = response.data.total
        // 以下是无奈之举, 如果有疑问,请阅读 element table 源代码
        this.$nextTick(() => {
          this.tableData.forEach(item => {
            if (item.id === id) { this.$refs.table.toggleRowSelection(item, true) }
          })
        })
        this.selectRowTemp = { id, name, orgName, loginName }
        this.tableLoading = false
      }).catch(error => {
        this.tableLoading = false
        this.tableData = []
        this.$message.error(error.msg || error.message)
      })
    },
    /** 添加 通用对象 */
    addGeneral() {
      if (!this.disabled) {
        this.searchForm = {
          name: '',
          orgName: '',
          loginName: ''
        }
        this.selectRowTemp = deepClone(this.selectRow)
        this.mainTableReload()
        this.generalSelectShow = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
:deep(th .el-checkbo) {
  display: none;
}
:deep(.el-tag) {
  margin-left: 10px;
}

:deep(tr .el-checkbox__inner) {
  border-radius: 10px;
}
.flow-user-select {
  width: 100%;
  font-size: 14px;
  line-height: 40px;
  border-radius: 5px;
  background-color: transparent;
  border: 1px solid #dcdfe6;
  &-addButton {
    margin-left: 10px;
  }
}
</style>
